import { render, staticRenderFns } from "./ProsesRaporlari.vue?vue&type=template&id=331762b6"
import script from "./ProsesRaporlari.vue?vue&type=script&lang=js"
export * from "./ProsesRaporlari.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports